import { cn } from '~/lib'

export default function MapListingCardSkeleton({
  className,
}: {
  className?: string
}) {
  return (
    <div className={cn(className, 'rounded-md bg-background shadow-md')}>
      <div className="animate-pulse">
        <div className="aspect-video rounded-t-md bg-gray-200 dark:bg-gray-700" />
        <div className="p-4">
          <div className="mb-2 h-6 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="mb-1 h-4 w-36 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="mb-1 h-4 w-36 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="mt-2 flex gap-2">
            <div className="h-6 w-24 rounded bg-gray-200 dark:bg-gray-700" />
            <div className="h-6 w-24 rounded bg-gray-200 dark:bg-gray-700" />
            <div className="h-6 w-24 rounded bg-gray-200 dark:bg-gray-700" />
          </div>
          <div className="mt-2 flex gap-2">
            <div className="h-6 w-24 rounded bg-gray-200 dark:bg-gray-700" />
            <div className="h-6 w-24 rounded bg-gray-200 dark:bg-gray-700" />
          </div>
          <div className="mt-4 flex items-center">
            <div className="mr-4 h-10 w-16 rounded bg-gray-200" />
            <div>
              <div className="h-4 w-48 rounded bg-gray-200 dark:bg-gray-700"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
